const rawBaseUrl = (process.env.REACT_APP_API_BASE_URL || '').trim();
const rawEnvironmentName = (process.env.REACT_APP_ENV_NAME || '').trim().toLowerCase();
const productionApiBaseUrl = 'https://api.bundledrop.app';
const stagingApiBaseUrl = 'https://api-staging.bundledrop.app';

const isStagingAdminHost = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  const hostname = window.location.hostname.toLowerCase();
  return hostname.includes('staging') || hostname.includes('develop');
};

const shouldUseStagingApi = () =>
  rawEnvironmentName === 'stag' ||
  rawEnvironmentName === 'staging' ||
  (rawBaseUrl.replace(/\/$/, '') === productionApiBaseUrl && isStagingAdminHost());

export const getApiBaseUrl = (): string => {
  if (!rawBaseUrl) {
    console.warn('REACT_APP_API_BASE_URL is not set; API calls will fail.');
  }

  if (shouldUseStagingApi()) {
    return stagingApiBaseUrl;
  }

  return rawBaseUrl.replace(/\/$/, '');
};
